import 'dayjs/locale/es'
import { Select } from 'antd'
import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useDashboardFilters } from '@contexts'

import { FilterGroup } from './styled'

dayjs.extend(isoWeek)
dayjs.locale('es')

const WEEK_OPTIONS_BACK = 6

const WeekSelector = () => {
  const { t } = useTranslation()
  const { weekStart, setWeekStart } = useDashboardFilters()

  const options = useMemo(() => {
    const baseMonday = dayjs().isoWeekday(1).startOf('day')
    return Array.from({ length: WEEK_OPTIONS_BACK }, (_, i) => {
      const monday = baseMonday.subtract(i, 'week')
      const label = `${t('admin_router.dashboard.week_selector_prefix')} ${monday.format(
        'DD/MM/YY',
      )}`
      const value = monday.toISOString()
      return { label, value }
    })
  }, [t])

  const normalizedMonday = dayjs(weekStart).isoWeekday(1).startOf('day')
  const match = options.find(o => dayjs(o.value).isSame(normalizedMonday, 'day'))
  const selectValue = match?.value ?? options[0]?.value

  return (
    <FilterGroup>
      <Select
        style={{ minWidth: 220 }}
        options={options}
        value={selectValue}
        onChange={iso => setWeekStart(dayjs(iso).toDate())}
      />
    </FilterGroup>
  )
}

export { WeekSelector }
